/* eslint-disable prefer-object-spread */

import { USER_TYPES } from '@md/users/constances'
import { User } from './user';

export function createStore({ receiveResource, UserClass = User }) {
  return {
    namespaced: true,

    state: {
      user: new UserClass({}, false),
      loading: false,
    },

    getters: {
      isDetermined: state => state.user.determined,
    },

    mutations: {
      setUser(state, data) {
        let user = JSON.parse(JSON.stringify(data))

        if (user.info.role) {
          user = { ...user, ...USER_TYPES[user.info.role] }
        }

        if (user.info.points && !user.info.points.length) {
          user.info.points = [{}]
        }

        state.user = user
      },

      UPDATE_USER(state, data) {
        let info = JSON.parse(JSON.stringify(data))
        info = { ...info, ...USER_TYPES[info.role] }
        state.user = new UserClass(Object.assign({}, state.user.info, info))
      },

      setLoading(state, value) {
        state.loading = value;
      },
    },

    actions: {
      initialReceive(store) {
        if (store.state.user.determined) {
          return null;
        }
        return store.dispatch('lockedReceive');
      },

      lockedReceive(store) {
        if (store.state.loading) {
          return null;
        }

        return store.dispatch('receive');
      },

      async receive(store) {
        store.commit('setLoading', true);

        return receiveResource.execute().then(res => {
          const { data: { item } } = res
          store.commit('setUser', new UserClass(item));
        }).catch(error => {
          store.commit('setUser', new UserClass({}));
          console.warn(error);
        }).finally(() => store.commit('setLoading', false));
      },
    },
  };
}
